<div class="page-layout blank p-24" fusePerfectScrollbar fxLayout="row">

    <!-- ASIDE -->
    <div fxFlex="19" fxFlex.xs="100" class="aside" fxHide.lt-md fxShow.gt-sm>
        <div>
            <img src="assets/images/iconos/icono_aportes.png" class="icon">
        </div>
    </div>
    <!-- END ASIDE -->

    <!-- CONTENT -->
    <div fxFlex="81" class="content" fxFlex.lt-md="100">

        <!-- BREADCRUMB -->
        <div class="breadcrumbs">
            <a (click)="linkPanel()">Panel de Inicio</a> » <a routerLink="/proveedores/otras-gestiones">Otras
                gestiones</a> » <span>Consulta de Facturación</span>
              
        </div>

        <!-- TÍTULO -->
        <h2 class="page-subtitle">Consulta de Facturación</h2>  
        <p>Por consultas sobre facturación de asociados correspondientes a Omint o Swiss Medical deberás dirigirte a los canales habilitados de cada Obra social a la cual te encuentres facturando.
        </p>
        <p>Cada consulta deberá ser realizada por periodo, prestación y beneficiario.</p>

        <!-- FORMULARIO -->
        <form [formGroup]="formularioConsultasFacturacion" (ngSubmit)="onSubmit()" novalidate>

            <div class="data">
                <div class="tw">
                    <mat-form-field class="mat-fullwidth">
                        <mat-label>Beneficiario</mat-label>
                        <input matInput formControlName="beneficiario" placeholder="Ingrese el nombre del beneficiario"
                            maxlength="120">
                        <mat-hint align="end">
                            {{formularioConsultasFacturacion.get('beneficiario')?.value?.length || 0}}/120
                        </mat-hint>
                        <mat-error
                            *ngIf="formularioConsultasFacturacion.get('beneficiario')?.hasError('required') && formularioConsultasFacturacion.get('beneficiario')?.touched">
                            El campo beneficiario es obligatorio.
                        </mat-error>
                        <mat-error *ngIf="formularioConsultasFacturacion.get('beneficiario')?.hasError('maxlength')">
                            El campo no puede exceder los 120 caracteres.
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- PERÍODO (MES Y AÑO) -->
            <div class="data">
                <div class="tw">
                    <mat-form-field class="mat-fullwidth">
                        <mat-label>Mes</mat-label>
                        <mat-select formControlName="mes">
                            <mat-option disabled>Seleccione mes</mat-option>
                            <mat-option *ngFor="let mes of meses" [value]="mes.value">
                                {{ mes.text }}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="formularioConsultasFacturacion.get('mes')?.hasError('required') && formularioConsultasFacturacion.get('mes')?.touched">
                            Debe seleccionar un mes.
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="tw">
                    <mat-form-field class="mat-fullwidth">
                        <mat-label>Año</mat-label>
                        <mat-select formControlName="anio">
                            <mat-option disabled>Seleccione año</mat-option>
                            <mat-option *ngFor="let anio of anios" [value]="anio">
                                {{ anio }}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="formularioConsultasFacturacion.get('anio')?.hasError('required') && formularioConsultasFacturacion.get('anio')?.touched">
                            Debe seleccionar un año.
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- PRESTACIÓN -->
            <div class="data">
                <div class="tw" fxFlex.xs="100">
                    <mat-form-field class="mat-fullwidth">
                        <mat-label>Prestación</mat-label>
                        <input matInput formControlName="prestacion" placeholder="Ingrese la prestación"
                            maxlength="200">
                        <mat-hint align="end">
                            {{formularioConsultasFacturacion.get('prestacion')?.value?.length || 0}}/200
                        </mat-hint>
                        <mat-error
                            *ngIf="formularioConsultasFacturacion.get('prestacion')?.hasError('required') && formularioConsultasFacturacion.get('prestacion')?.touched">
                            El campo prestación es obligatorio.
                        </mat-error>
                        <mat-error *ngIf="formularioConsultasFacturacion.get('prestacion')?.hasError('maxlength')">
                            El campo no puede exceder los 200 caracteres.
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- PUNTO DE VENTA Y NÚMERO DE FACTURA -->
            <div class="data">
                <div class="tw">
                    <mat-form-field class="mat-fullwidth">
                        <mat-label>Punto de venta</mat-label>
                        <input matInput formControlName="puntoVenta" (focusout)="puntoVentaAddCharacter()"
                            (keypress)="keyPressNumbers($event)" maxlength="5" type="text" placeholder="12345">
                        <mat-error
                            *ngIf="formularioConsultasFacturacion.get('puntoVenta')?.hasError('required') && formularioConsultasFacturacion.get('puntoVenta')?.touched">
                            El punto de venta es obligatorio.
                        </mat-error>
                        <mat-error *ngIf="formularioConsultasFacturacion.get('puntoVenta')?.hasError('pattern')">
                            Debe ingresar los 5 dígitos del punto de venta.
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="tw">
                    <mat-form-field class="mat-fullwidth">
                        <mat-label>Número de factura</mat-label>
                        <input matInput formControlName="numeroFactura" (focusout)="numeroFacturaAddCharacter()"
                            (keypress)="keyPressNumbers($event)" maxlength="8" type="text" placeholder="12345678">
                        <mat-error
                            *ngIf="formularioConsultasFacturacion.get('numeroFactura')?.hasError('required') && formularioConsultasFacturacion.get('numeroFactura')?.touched">
                            El número de factura es obligatorio.
                        </mat-error>
                        <mat-error *ngIf="formularioConsultasFacturacion.get('numeroFactura')?.hasError('pattern')">
                            Debe ingresar los 8 dígitos del número de factura.
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- OBRA SOCIAL -->
            <div class="data">
                <div class="tw" fxFlex.xs="100">
                    <mat-form-field class="mat-fullwidth">
                        <mat-label>Obra Social</mat-label>
                        <mat-select formControlName="obraSocial">
                            <mat-option disabled>Seleccione obra social</mat-option>
                            <mat-option *ngFor="let obra of obrasSociales" [value]="obra.value">
                                {{ obra.text }}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="formularioConsultasFacturacion.get('obraSocial')?.hasError('required') && formularioConsultasFacturacion.get('obraSocial')?.touched">
                            Debe seleccionar una obra social.
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

        </form>

        <!-- ADJUNTOS (copiado de carga-factura) -->
        <div id="adjuntos">
            <form [formGroup]="formularioConsultasFacturacion" enctype="multipart/form-data">
                <mat-accordion multi="true" id="accordion">
                    <mat-expansion-panel disabled expanded>
                        <mat-expansion-panel-header class="fixed-header">
                            <mat-panel-title>
                                <p>
                                    <mat-icon matSuffix>folder</mat-icon><strong>Adjuntar Documentación
                                        (Opcional)</strong>
                                    3MB máximo. Formatos válidos: Comprobantes PDF. Planilla de Asistencia DOC, PDF,
                                    JPG, PNG.
                                </p>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="data">
                            <div class="tw">
                                <mat-form-field appearance="standard" class="mat-fullwidth">
                                    <mat-label>Comprobante</mat-label>
                                    <ngx-mat-file-input formControlName="adjComprobante" #adjComprobante
                                        [accept]="'.pdf'" (click)="reminder()">
                                    </ngx-mat-file-input>
                                    <mat-icon matSuffix *ngIf="adjComprobante.empty">add</mat-icon>
                                    <button mat-icon-button matSuffix *ngIf="!adjComprobante.empty"
                                        (click)="adjComprobante.clear($event)">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                    <mat-error *ngIf="formularioConsultasFacturacion.get('adjComprobante')?.hasError('maxContentSize') 
                                        || formularioConsultasFacturacion.get('adjComprobante')?.hasError('mimeType')">
                                        Debe adjuntar un archivo válido (PDF, 3MB máximo).
                                    </mat-error>
                                    <mat-error
                                        *ngIf="formularioConsultasFacturacion.get('adjComprobante')?.hasError('minContentSize')">
                                        Debe adjuntar un archivo que no esté vacío (PDF, 1KB mínimo).
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="data">
                            <div class="tw">
                                <mat-form-field appearance="standard" class="mat-fullwidth">
                                    <mat-label>Planilla de asistencia</mat-label>
                                    <ngx-mat-file-input formControlName="adjPlanilla" #adjPlanilla
                                        [accept]="'.jpg, .png, .pdf, .doc, .docx'">
                                    </ngx-mat-file-input>
                                    <mat-icon matSuffix *ngIf="adjPlanilla.empty">add</mat-icon>
                                    <button mat-icon-button matSuffix *ngIf="!adjPlanilla.empty"
                                        (click)="adjPlanilla.clear($event)">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                    <mat-error
                                        *ngIf="formularioConsultasFacturacion.get('adjPlanilla')?.hasError('maxContentSize') || formularioConsultasFacturacion.get('adjPlanilla')?.hasError('mimeType')">
                                        Debe adjuntar un archivo válido (DOC, PDF, JPG ó PNG, 3MB máximo).
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>

                <div fxLayout="row">
                    <button type="button" mat-raised-button id="btnEnviar" (click)="onSubmit()">Enviar</button>
                    <button type="button" mat-raised-button id="btnCancelar" (click)="goBack()">Volver</button>
                </div>
            </form>
        </div>

    </div>
</div>